var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M845.815 750.614h0.059v-0.364l-0.059 0.364z m0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M960.232 511.185l-112.423-64.309 111.607-63.741L511.16 126.72 63.073 383.145l112.382 64.205-111.566 63.845 113.337 64.751-113.462 64.93 448.087 255.999 448.255-256.009-113.38-64.857 113.506-64.824z m-793.109-128.04L511.16 190.889l342.099 192.256-58.835 33.193-283.404 159.89-283.059-158.925-60.838-34.158z m572.839 63.92L511.02 576.228 281.833 447.549 511.02 576.228l228.942-129.163z m-572.022 64.13l60.292-33.693L511.16 639.144 794.153 477.52l59.922 33.676L511.16 691.801 167.94 511.195z m686.011 129.682L511.713 833.96 167.816 640.877l62.211-34.765 281.95 161.082 281.087-160.536 60.887 34.219z",
    fill: "#4ee44e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.31814f43a75b4bb4122f45244c6f669c.svg";
export { ForwardRef as ReactComponent };